import { useQuery } from '@gogame/query';

import { loadMetrics } from 'scenes/RegsStats/sources/regsStats';

import { metrics } from './queryKeyFactory';

export const useLoadMetrics = () => {
  return useQuery(metrics(), (_, { signal }) => loadMetrics({}, { signal }));
};
